import { useMatchMedia } from "@/hooks/useMatchMedia";

const REDUCED_MOTION_QUERY = "(prefers-reduced-motion: reduce)";

/**
 * Tracks the user's reduced-motion preference and updates when it changes at runtime.
 */
export function usePrefersReducedMotion(): boolean {
    return useMatchMedia(REDUCED_MOTION_QUERY);
}
